import { type GamificationBehaviorRefined } from '@capsicum/common';
import { useCallback } from 'react';

import { useGamificationBehaviorsQuery } from '../data-access';

export const useGamificationBehaviors = () => {
	const { data: behaviors } = useGamificationBehaviorsQuery();

	const getBehaviorBy = useCallback(
		(predicate: (b: GamificationBehaviorRefined) => boolean) => behaviors?.find(predicate),
		[behaviors]
	);

	return {
		gamificationBehaviors: behaviors,
		getBehaviorBy
	};
};
